// extracted by mini-css-extract-plugin
module.exports = {"text":"TypographyCropped_text__0vEJ2","button-more":"TypographyCropped_button-more__TeizV"};